import type { BluffVoteOption } from "./answerBluffGamePayload";

function hashSeed(s: string): number {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

function mulberry32(seed: number): () => number {
  return () => {
    let t = (seed += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/**
 * Deterministic shuffle so every client shows the same order for a given vote round,
 * but order is pseudo-random across rounds (truth is not in a fixed slot).
 */
export function shuffleBluffVoteOptionsDeterministic(options: BluffVoteOption[], seed: string): BluffVoteOption[] {
  if (options.length <= 1) return [...options];
  const out = [...options];
  const rnd = mulberry32(hashSeed(seed));
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(rnd() * (i + 1));
    const tmp = out[i]!;
    out[i] = out[j]!;
    out[j] = tmp;
  }
  return out;
}

export function bluffVoteOptionsShuffleSeed(
  roundIndex: number,
  phaseEndsAt: string | null | undefined,
  options: BluffVoteOption[],
): string {
  const body = options.map((o) => `${o.id}\u001d${o.text}`).join("\u001e");
  return `${roundIndex}\u001f${phaseEndsAt ?? ""}\u001f${body}`;
}
